// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { title } from 'process';
import { Translate } from '@mui/icons-material';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
  charger: getIcon('ic_charger'),
  car: getIcon('ic_car'),
  settings: getIcon('ic_settings'),
  payments: getIcon('ic_payments'),
  userGroup: getIcon('flowbite--users-group-solid'),
};

export default function NavConfig() {
  return [
    {
      subheader: '',
      items: [
        {
          title: 'dashboard',
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard,
          roles: ['Admin', 'Provider', 'Agent'],
        },

        { title: 'users', path: PATH_DASHBOARD.general.users, icon: ICONS.user },
        {
          title: 'userGroups',
          path: PATH_DASHBOARD.general.providerGroups.list,
          icon: ICONS.userGroup,
          roles: ['Provider', 'Admin', 'Agent'],
        },

        { title: 'agents', path: PATH_DASHBOARD.general.agents, icon: ICONS.user, roles: ['Admin'] },
        { title: 'providers', path: PATH_DASHBOARD.general.providers, icon: ICONS.user, roles: ['Admin', 'Agent'] },

        {
          title: 'chargersManagement',
          path: PATH_DASHBOARD.general.chargers,
          icon: ICONS.charger,

          children: [
            { title: 'chargers', path: PATH_DASHBOARD.general.chargersList },
            { title: 'ocppChargers', path: PATH_DASHBOARD.general.ocppChargers },
            {
              title: 'chargersWithoutProvisioning',
              path: PATH_DASHBOARD.general.chargersWithoutLocationList,
            },
            { title: 'map', path: PATH_DASHBOARD.general.chargersMap },
            {
              title: 'chargerGroups',
              path: PATH_DASHBOARD.general.chargerGroups.list,
              roles: ['Provider', 'Admin', 'Agent'],
            },

            // { title: 'chargerLogs', path: PATH_DASHBOARD.general.chargersLogs, roles: ['Admin'] },
            // {title: 'chargingSessions', path: PATH_DASHBOARD.general.chargingSessions, roles: ['Admin']},
          ],
        },
        {
          title: 'vehiclesManagement',
          path: PATH_DASHBOARD.general.vehicles,
          icon: ICONS.car,
          roles: ['Admin'],

          children: [
            { title: 'vehicles', path: PATH_DASHBOARD.general.vehicles },
            { title: 'brands', path: PATH_DASHBOARD.general.vehicleBrand },
            { title: 'models', path: PATH_DASHBOARD.general.vehicleModel },
            { title: 'outletTypes', path: PATH_DASHBOARD.general.outletType },
          ],
        },

        {
          title: 'paymentsManagement',
          path: PATH_DASHBOARD.general.paymentLogs,
          icon: ICONS.payments,
          roles: ['Admin', 'Provider', 'Agent'],

          children: [
            {
              title: 'chargementList',
              path: PATH_DASHBOARD.general.payments,
              roles: ['Admin', 'Provider', 'Agent'],
            },
            { title: 'paymentLogs', path: PATH_DASHBOARD.general.paymentLogs, roles: ['Admin'] },
            {
              title: 'chargingReports',
              path: PATH_DASHBOARD.general.chargingReport,
              roles: ['Admin', 'Provider', 'Agent'],
            },
            { title: 'invoices', path: PATH_DASHBOARD.general.invoices, roles: ['Admin'] },
          ],
        },
        // -------------------------------------------------------
        {
          title: 'creditsManagement',
          path: PATH_DASHBOARD.general.credits,
          icon: ICONS.payments,
          roles: ['Admin', 'Provider', 'Agent'],

          children: [
            {
              title: 'transactions',
              path: PATH_DASHBOARD.general.credits,
              roles: ['Admin', 'Provider', 'Agent'],
            },
            {
              title: 'tariffs',
              path: PATH_DASHBOARD.general.tariffs,
              roles: ['Admin'],
            },
            { title: 'balance', path: PATH_DASHBOARD.general.balance, roles: ['Provider', 'Agent'] },
          ],
        },

        {
          title: 'settings',
          path: PATH_DASHBOARD.general.settings,
          icon: ICONS.settings,
          roles: ['Admin', 'Provider', 'Agent'],
          children: [
            { title: 'chargingProfiles', path: PATH_DASHBOARD.general.chargingProfiles, roles: ['Admin', 'Provider', 'Agent'] },
            { title: 'firmwares', path: PATH_DASHBOARD.general.firmwares, roles: ['Admin'] },
            { title: 'taxes', path: PATH_DASHBOARD.general.listTaxes, roles: ['Admin'] },
            { title: 'RFID Tags', path: PATH_DASHBOARD.general.rfidTags, roles: ['Admin', 'Provider', 'Agent'] },
            // {title: 'chargers', path: PATH_DASHBOARD.general.chargerSettings},
            // {title: 'networks', path: PATH_DASHBOARD.general.networkSettings},
          ],
        },
      ],
    },
  ];
}
